import { CYBER_ASSESSMENT } from './cyber';
import { SINGLE_CATEGORY } from './singleCategory';

export const ASSESSMENTS = { SINGLE_CATEGORY, CYBER_ASSESSMENT };
